import { createSelector } from "reselect";
import type { State } from "../../reducers/redirectInfo";

import type { State as RedirectStoreState } from "../../pages/AppStoreWrapper";

export const getRedirectId = createSelector(
  (state: RedirectStoreState): State => state.redirect,
  (redirectInfo: State): string => redirectInfo.get("id")
);

export const getRedirectInfo = createSelector(
  (state: RedirectStoreState): State => state.redirect,
  (redirectInfo: State): State => redirectInfo
);
